import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import {
  SubHeadTitle,
  ImageWrap,
  KeyStyle,
  ValueStyle
} from "../Details/styles";
import profileIcon from "../../../../../../assets/icons/profile-3.svg";
import { filterDataWithValue } from "../../../Data/FilterDropDownData";
import moment from "moment";
import { MarginBottom } from "../AccordionContent/styles";
import {
  EllipsisUnderline, EllipsisDataValueWrapper,
 EllipsisPointer, EllipsisContent
} from "../../../../../../CommonComponents/commonStyles";
import { basicImports, basicSuccessorsInfo } from '../../../DefaultPropTypes';

export const AccordionOpenStateContent = props => {
  const getFormattedDOB = () => {
    let dob = new Date(props.successor.dob).toDateString();
    let dobDate = moment(dob);
    return moment(dobDate).format("MM/DD/YYYY");
  };
  return (
    <div>
      {props.contentKey === 1 ? (
        <SubHeadTitle paddingTop="0">
          <ImageWrap marginRight="10px" src={profileIcon}  alt="Profile" />
          Successor {props.index + 1}
        </SubHeadTitle>
      ) : (
        <SubHeadTitle paddingTop="0">
          <ImageWrap marginRight="10px" src={profileIcon} alt="Profile" />
          Successor Account {props.index + 1}
        </SubHeadTitle>
      )}
      <MarginBottom marginBottom="20px">
        {props.successor.title ? (
          <ValueStyle marginLeft="26px" lineHeight="2">
            {props.successor.title}&nbsp;{props.successor.firstName}&nbsp;
            {props.successor.middleName ? props.successor.middleName : ""}&nbsp;
            {props.successor.lastName}&nbsp;
            {props.successor.suffix ? props.successor.suffix : ""}&nbsp;
          </ValueStyle>
        ) : (
          <ValueStyle marginLeft="26px" lineHeight="2">
            {props.successor.firstName}&nbsp;{props.successor.middleName ? props.successor.middleName : ""}&nbsp;{props.successor.lastName}
            {props.successor.suffix ? props.successor.suffix : ""}&nbsp;
          </ValueStyle>
        )}
        <div>
          <KeyStyle lineHeight="2" marginLeft="26px">
            Relation:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.relationshipType}
            </ValueStyle>
          </KeyStyle>
        </div>
        <div>
          <KeyStyle lineHeight="2" marginLeft="26px">
            Email:&nbsp;
            <ValueStyle lineHeight="2">
              <EllipsisDataValueWrapper>
                <EllipsisUnderline>{props.successor.preferedEmail}</EllipsisUnderline>
                  <EllipsisContent>                  
                      {props.successor.preferedEmail}
                  </EllipsisContent>
              </EllipsisDataValueWrapper>  
            </ValueStyle>
          </KeyStyle>
        </div>
        <div>
          <KeyStyle lineHeight="2" marginLeft="26px">
            Phone:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.preferedPhone}
            </ValueStyle>
          </KeyStyle>
        </div>
        <div>
          <KeyStyle lineHeight="2" marginLeft="26px">
            Address:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.address.line1},
            </ValueStyle>
            {props.successor.address.line2 ? (
              <div>
                <ValueStyle lineHeight="2" marginLeft="67px">
                  {props.successor.address.line2},
                </ValueStyle>
              </div>
            ) : null}
            {props.successor.address.line3 ? (
              <div>
                <ValueStyle lineHeight="2" marginLeft="67px">
                  {props.successor.address.line3},
                </ValueStyle>
              </div>
            ) : null}
            <div>
              <ValueStyle lineHeight="2" marginLeft="67px">
                {props.successor.address.city}&nbsp;
                {props.successor.address.state}&nbsp;
                {props.successor.address.zip},
              </ValueStyle>
            </div>
            <div>
              <ValueStyle lineHeight="2" marginLeft="67px">
                {
                  filterDataWithValue(
                    props.successor.address.country,
                    props.countryDropdown
                  )[0].desc
                }
              </ValueStyle>
            </div>
          </KeyStyle>
        </div>
        <div>
          <KeyStyle lineHeight="2" marginLeft="26px">
            Date of Birth:&nbsp;
            <ValueStyle lineHeight="2">{getFormattedDOB()}</ValueStyle>
          </KeyStyle>
        </div>
      </MarginBottom>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  percentage: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions",
    `${ownProps.contentKey - 1}`,
    "percentage"
  ]),
  countryDropdown: state.getIn([
    "npaFormReducer",
    "dropdownValues",
    "data",
    "countries"
  ])
});

AccordionOpenStateContent.propTypes = {
  contentKey: PropTypes.number,
  countryDropdown: basicImports,
  dispatch: PropTypes.func,
  id: PropTypes.string,
  index: PropTypes.number,
  percentage: PropTypes.string,
  successor: basicSuccessorsInfo
}

export default connect(mapStateToProps)(AccordionOpenStateContent);
